import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomToolTip',
  props: {
  toolTipType: {
    type: String,
    default: 'customtoottip'
  },
  toolTipText: {
    type: String,
    default: 'This is a tooltip'
  },
  disableTooltip: {
    type: Boolean
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.disableTooltip)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(__props.toolTipType + 'tooltip-container')
      }, _toDisplayString(__props.toolTipText), 3))
    : _createCommentVNode("", true)
}
}

})